module.exports = __webpack_public_path__ + "resources/img/solution_finance_infra.3328d49475ad99a16944e4ad9014093a.png";